import Request from '@hotmart-org-ca/request'

import { GetAcceptedResponse, LeadPayload, GetAcceptedPayload, PostLeadResponse } from '../types'
import RequestHelper from 'common/helpers/request'

import './request'

export default class LeadService {
  static async postLead(payload: LeadPayload) {
    try {
      const response = await Request('post.lead', payload)

      return response as PostLeadResponse
    } catch (error) {
      RequestHelper.errorHandling(error)
      return void 0
    }
  }

  static getAccepted = async (payload: GetAcceptedPayload) => {
    const response = await Request('get.lead.accepted', payload) as GetAcceptedResponse

    return response
  }
}
